<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    leave-active-class="transition-all duration-300 ease-in"
    enter-from-class="-translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="-translate-y-full opacity-0">
    <div class="relative" v-if="appStore.progressDisplayText">
      <DProgressBar
        :value="appStore.progress"
        style="height: 13px"
        :class="[appStore.progress ? 'bg-primary/80' : 'bg-primary']"
        :show-value="false" />
      <div class="text-surface-800 absolute inset-0 inline-flex items-center justify-center py-1 text-sm font-medium">
        {{ displayProgressValue }}
      </div>
    </div>
  </Transition>
</template>
<script setup>
import { useAppStore } from '@/stores/appStore';
import { DProgressBar } from '@disguise/cloud-ui';
import { computed, ref, watch } from 'vue';

const appStore = useAppStore();
const timeoutId = ref(null);

const displayProgressValue = computed(() => {
  let displayText = null;
  if (appStore.progressDisplayText && appStore.progress) {
    displayText = `${appStore.progressDisplayText} (${appStore.progress}%)`;
  }
  if (displayText) return displayText;
  return appStore.progressDisplayText || '';
});

watch(
  () => appStore.progress,
  (newVal) => {
    if (newVal === 100) {
      if (timeoutId.value) clearTimeout(timeoutId.value);
      timeoutId.value = setTimeout(() => {
        appStore.setProgress(0);
        appStore.setProgressDisplayText(null);
      }, 1000);
    }
  }
);
</script>
